import React from 'react';

interface SeparatorProps extends React.HtmlHTMLAttributes<HTMLDivElement> {
  color?: string;
  title?: string;
  variant?: 'dashed' | 'solid';
  width?: number;
}

function Separator({ color = '#0C8188', variant = 'dashed', width = 1, ...props }: SeparatorProps) {
  return (
    <div style={{ position: 'relative', lineHeight: 0, ...props.style }}>
      {variant === 'solid' && <div className='hdn_separator' style={{ borderWidth: `${width}px`, borderStyle: 'solid', borderColor: color }} />}
      {variant === 'dashed' && <div style={{ borderBottom: `1px dashed ${color}`, width: '100%' }} />}

      {/* Note (25 Nov 2025): Replaced SVG separator to match border with accordion in bootstrap (Did not change bootstrap due to syncing issues) */}
      {/* {variant === "dashed"
        && (
          <svg height="1px" width="100%">
            <g fill="none" stroke={color} strokeWidth="2px">
              <path strokeDasharray="3,3" d="M-1.55 0 l9999 0" />
            </g>
          </svg>
        )} */}

      {props.title && (
        <div className='hdn_separator__title-wrapper'>
          <div style={{ display: 'flex', alignContent: 'center', justifyContent: 'center' }}>
            <p className='m-0'>{props.title}</p>
          </div>
        </div>
      )}
    </div>
  );
}

export default Separator;
